import { useLocalMicrophoneTrack, useLocalCameraTrack, usePublish, useJoin, useRemoteUsers } from 'agora-rtc-react';
import { AGORA_APP_ID } from '../../../config';
import { useEffect } from 'react';

export function useAgoraRoom({ agoraToken, agoraChannel, micOn, cameraOn, connect }) {
  const { localMicrophoneTrack } = useLocalMicrophoneTrack(micOn);
  const { localCameraTrack } = useLocalCameraTrack(cameraOn);

  useEffect(() => {
    return () => {
      localMicrophoneTrack?.stop();
      localMicrophoneTrack?.close();

      localCameraTrack?.stop();
      localCameraTrack?.close();
    };
  }, []);

  const calling = Boolean(agoraToken && agoraChannel && connect);
  const { data, error, isConnected, isLoading } = useJoin(
    {
      appid: AGORA_APP_ID,
      channel: agoraChannel,
      token: agoraToken,
      uid: null,
    },
    calling,
  );

  usePublish([localMicrophoneTrack, localCameraTrack]);

  const remoteUsers = useRemoteUsers();
  console.log('remoteUsers', remoteUsers);

  return {
    data,
    error,
    isConnected,
    isLoading,
    localMicrophoneTrack,
    localCameraTrack,
    remoteUser: remoteUsers[0] || null,
  };
}
